//react...
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import FooterLogo from "../Logo/FooterLogo";

//styles...
import "./Footer.styles.css";

//data...
import APP_DATA from "../../APP_DATA";

const Footer = () => {
  const company = APP_DATA.company;
  return (
    <Container className="footer bg-dark pb-3 mt-5">
      <Row>
        <Col xs={12} md={6}>
          <Link to="/home" className="footer-logo p-4 d-inline-block">
            <Container className="ms-4">
              <FooterLogo className="ms-5" />
              <br />
              <span className="ms-2">Armco</span>
              <span className="ms-2">Trading</span>
            </Container>
          </Link>
        </Col>
        <Col xs={12} md={6}>
          <Container className="footer-typo mt-5 me-3">
            <span>
              Email : {company.email}
              <br />
              Phone : {company.phone} <br /> Address : {company.address} 
            </span>
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
